export const getGeoLocation = () =>
    new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            return reject(new Error('Geolocation not supported'));
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                resolve({ latitude, longitude });
            },
            (error) => {
                console.error('Geolocation error:', error);
                resolve({ latitude: 0, longitude: 0 });
            },
            {
                enableHighAccuracy: true, // Bắt buộc dùng GPS nếu có
                timeout: 10000,
                maximumAge: 0,
            }
        );
    });
